import { render, staticRenderFns } from "./RoleRemove.vue?vue&type=template&id=1ef4c51c&scoped=true"
import script from "./RoleRemove.vue?vue&type=script&lang=js"
export * from "./RoleRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef4c51c",
  null
  
)

export default component.exports